export default "__VITE_ASSET__4ddac09d__"